import React from 'react';
import { Briefcase } from 'lucide-react';

const Experience = () => {
  const roles = [
    {
      role: 'Backend Developer Intern',
      company: 'C8nnect IT Solutions',
      dates: 'February 2026 — June 2026',
      highlights: [
        'Developed and maintained backend services using Node.js, TypeScript, and Express.js.',
        'Integrated frontend components with backend services and managed PostgreSQL databases with Drizzle ORM.',
        'Implemented JWT authentication and role-based access control for secure user management.',
        'Built real-time notification features using WebSocket technology.',
      ],
    },
    {
      role: 'Full Stack Developer Intern',
      company: 'C8nnect IT Solutions',
      dates: 'April 2026 — May 2026',
      highlights: [
        'Built React and Vite interfaces connected to backend APIs.',
        'Developed backend services with Node.js, TypeScript, Express, and PostgreSQL.',
        'Implemented JWT authentication and RBAC for multi-role access.',
        'Used Drizzle ORM for database models, migrations, and queries; added real-time notifications and Swagger API documentation.',
      ],
    },
    {
      role: 'Service Crew',
      company: "McDonald's Fuente Osmeña",
      dates: 'August 2024 — Present',
      highlights: [
        "Prepared food items according to McDonald's standardized recipes and quality standards.",
        'Maintained food safety and sanitation standards in compliance with health regulations.',
        'Collaborated with team members to ensure timely order completion during peak hours.',
      ],
    },
  ];

  return (
    <section id="experience" className="border-y border-slate-200 bg-white px-4 py-20 sm:px-6 lg:px-8">
      <div className="mx-auto max-w-6xl">
        <div className="mb-12 max-w-2xl">
          <p className="text-sm font-bold uppercase tracking-[0.2em] text-cyan-700">Experience</p>
          <h2 className="mt-3 text-4xl font-bold tracking-tight text-slate-950 sm:text-5xl">Learning by building.</h2>
        </div>
        <div className="space-y-5">
          {roles.map((job) => (
            <article key={`${job.role}-${job.dates}`} className="rounded-2xl border border-slate-200 bg-slate-50 p-6 transition hover:border-cyan-300 hover:bg-white hover:shadow-lg hover:shadow-slate-200/70 sm:p-8">
              <div className="flex flex-col justify-between gap-3 border-b border-slate-200 pb-5 sm:flex-row sm:items-start">
                <div className="flex items-start gap-4">
                  <span className="grid h-10 w-10 shrink-0 place-items-center rounded-xl bg-cyan-100 text-cyan-800"><Briefcase size={19} /></span>
                  <div>
                    <h3 className="text-xl font-bold text-slate-950">{job.role}</h3>
                    <p className="mt-1 font-medium text-slate-600">{job.company}</p>
                  </div>
                </div>
                <p className="text-sm font-semibold text-cyan-800 sm:text-right">{job.dates}</p>
              </div>
              <ul className="mt-5 grid gap-3 text-sm leading-6 text-slate-600 sm:grid-cols-2">
                {job.highlights.map((highlight) => <li key={highlight} className="flex gap-3"><span className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-cyan-500" />{highlight}</li>)}
              </ul>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Experience;
